import React, { useState } from 'react';
import { PlusIcon, TrashIcon, InfoIcon, PackageIcon } from 'lucide-react';
export function ProjectItemsStep({
  initialData = [],
  onUpdate
}) {
  const [items, setItems] = useState(initialData.length ? initialData : [{
    name: '',
    description: '',
    quantity: 1,
    price: 0
  }]);
  const handleAddItem = () => {
    const newItems = [...items, {
      name: '',
      description: '',
      quantity: 1,
      price: 0
    }];
    setItems(newItems);
    onUpdate(newItems);
  };
  const handleRemoveItem = index => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
    onUpdate(newItems);
  };
  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      [field]: value
    };
    setItems(newItems);
    onUpdate(newItems);
  };
  // Calculate total
  const total = items.reduce((sum, item) => sum + (item.price || 0), 0);
  return <div className="space-y-6" data-id="element-4223">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4224">Project Items</div>
      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-4225">
        <div className="flex items-start" data-id="element-4226">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-4227" />
          <div data-id="element-4228">
            <h3 className="text-white font-medium mb-1" data-id="element-4229">Project Items Guide</h3>
            <p className="text-blue-200 text-sm" data-id="element-4230">
              Add all the components and services that will be included in this
              project quote. Be specific with descriptions to avoid
              misunderstandings.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-4231">
        <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-4232">
          <div className="col-span-5" data-id="element-4233">Item</div>
          <div className="col-span-4" data-id="element-4234">Description</div>
          <div className="col-span-1 text-center" data-id="element-4235">Qty</div>
          <div className="col-span-2 text-right pr-8" data-id="element-4236">Price</div>
        </div>
        <div className="p-2" data-id="element-4237">
          {items.map((item, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-4238">
              <div className="col-span-5" data-id="element-4239">
                <input type="text" value={item.name} onChange={e => handleItemChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Item name" data-id="element-4240" />
              </div>
              <div className="col-span-4" data-id="element-4241">
                <input type="text" value={item.description} onChange={e => handleItemChange(index, 'description', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Brief description" data-id="element-4242" />
              </div>
              <div className="col-span-1" data-id="element-4243">
                <input type="number" value={item.quantity} onChange={e => handleItemChange(index, 'quantity', parseInt(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" data-id="element-4244" />
              </div>
              <div className="col-span-1" data-id="element-4245">
                <div className="relative" data-id="element-4246">
                  <span className="absolute left-3 top-2 text-gray-400" data-id="element-4247">$</span>
                  <input type="number" value={item.price} onChange={e => handleItemChange(index, 'price', parseFloat(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-7 pr-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4248" />
                </div>
              </div>
              <div className="col-span-1 flex justify-center" data-id="element-4249">
                {items.length > 1 && <button onClick={() => handleRemoveItem(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4250">
                    <TrashIcon size={16} data-id="element-4251" />
                  </button>}
              </div>
            </div>)}
        </div>
        <div className="p-4 border-t border-blue-800/30" data-id="element-4252">
          <button onClick={handleAddItem} className="w-full py-2.5 rounded-lg border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex items-center justify-center" data-id="element-4253">
            <PlusIcon size={18} className="mr-2" data-id="element-4254" />
            Add Another Item
          </button>
        </div>
      </div>
      {/* Total section */}
      <div className="flex justify-end" data-id="element-4255">
        <div className="bg-slate-800/50 rounded-xl p-4 border border-blue-800/30 w-64" data-id="element-4256">
          <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-4257">
            <span data-id="element-4258">Subtotal:</span>
            <span className="text-white" data-id="element-4259">${total.toFixed(2)}</span>
          </div>
          <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-4260">
            <div className="flex justify-between items-center" data-id="element-4261">
              <span className="font-medium text-white" data-id="element-4262">Total:</span>
              <span className="text-xl font-bold text-white" data-id="element-4263">
                ${total.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Item categories */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4264">
        <div className="flex items-center mb-4" data-id="element-4265">
          <PackageIcon size={20} className="text-blue-400 mr-2" data-id="element-4266" />
          <h3 className="text-white font-medium" data-id="element-4267">Common Project Items</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-4268">
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Center Pivot System',
            description: 'Complete center pivot irrigation system',
            quantity: 1,
            price: 70000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4269">
            <h4 className="text-white font-medium mb-1" data-id="element-4270">Center Pivot</h4>
            <p className="text-xs text-blue-300" data-id="element-4271">Complete irrigation system</p>
          </button>
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Pump Station',
            description: 'Water pumping station with controls',
            quantity: 1,
            price: 25000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4272">
            <h4 className="text-white font-medium mb-1" data-id="element-4273">Pump Station</h4>
            <p className="text-xs text-blue-300" data-id="element-4274">Water pumping equipment</p>
          </button>
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Control System',
            description: 'Advanced irrigation control system',
            quantity: 1,
            price: 15000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4275">
            <h4 className="text-white font-medium mb-1" data-id="element-4276">Control System</h4>
            <p className="text-xs text-blue-300" data-id="element-4277">Automation & monitoring</p>
          </button>
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Installation Service',
            description: 'Professional installation and setup',
            quantity: 1,
            price: 20000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4278">
            <h4 className="text-white font-medium mb-1" data-id="element-4279">Installation</h4>
            <p className="text-xs text-blue-300" data-id="element-4280">Professional setup service</p>
          </button>
        </div>
      </div>
    </div>;
}